interface StatCardProps {
  label: string;
  value: string;
  subtext: string;
  valueColor?: string;
}

export function StatCard({ label, value, subtext, valueColor = '#1B365D' }: StatCardProps) {
  return (
    <div className="bg-white rounded-lg border border-[#E2E8F0] p-4">
      <div className="text-[12px] font-semibold text-[#718096] mb-2">
        {label}
      </div>
      <div className="text-[28px] font-semibold mb-1 font-mono" style={{ color: valueColor }}>
        {value}
      </div>
      <div className="text-[12px] text-[#718096]">
        {subtext}
      </div>
    </div>
  );
}
